import api from './api';

// Tenant config (VAT rate, financial-year start month, …).
export const configService = {
  getConfig: async () => {
    const res = await api.get('/config');
    return res.data;
  },
  // payload: { vat_rate, fy_start_month, ... }
  saveConfig: async (config) => {
    const res = await api.put('/config', { config });
    return res.data;
  },

  // Per-module, per-version setting (admin_config). Version comes from the
  // request context header.
  getModuleConfig: async (module, item) => {
    const res = await api.get('/config/module', { params: { module, item } });
    return res.data;
  },
  setModuleConfig: async (module, item, value) => {
    const res = await api.put('/config/module', { module, item, value });
    return res.data;
  },

  // Overtime / allowance / public-holiday rules (md_config.labour_rules).
  // Returns { rules, sites } — sites so the page can offer "all sites" or a
  // named site exception without a second call.
  getLabourRules: async () => {
    const res = await api.get('/config/labour-rules');
    return res.data;
  },
  saveLabourRules: async (rules) => {
    const res = await api.put('/config/labour-rules', { rules });
    return res.data;
  },

  // Single sign-on (md_config.sso_config). Admin only.
  //
  // THE CLIENT SECRET NEVER COMES BACK. getSso returns `secret_set: true|false`
  // and nothing else about it; saveSso omits the field unless the administrator
  // is deliberately replacing it, and the server treats an absent secret as
  // "keep the stored one" rather than "clear it".
  getSso: async () => {
    const res = await api.get('/config/sso');
    return res.data;
  },
  saveSso: async (config) => {
    const res = await api.put('/config/sso', { config });
    return res.data;
  },

  // Public — the login page calls this before anyone has authenticated, so it
  // returns only enough to draw a button.
  getPublicSso: async () => {
    const res = await api.get('/users/sso');
    return res.data;
  },
};

export default configService;
